module.exports = __webpack_public_path__ + "img/basic.13a69b8b.png";